import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from 'antd';

import { selectDarkMode } from '../../../../userBrowserSettings/store/browserSettings.selectors';

import VersionHistoryButton from './VersionHistoryButton';
import VersionItem from './VersionItem';
import {
    contentOptimizerBriefSubTabKey,
    contentOptimizerLSTabKey,
} from '../../../../constants/contentOptimizer';

import { getThemeColorClass } from '../../../../utils/helpers/themeHelpers';
import { briefOutlineTabs } from '../../../pages/contentOptimizer/contentPage/contentOptimizerContentConstants';

const classes = {
    versionDropdownMenuItemContent: 'version-dropdown-menu-item-content',
    versionHistoryInput: 'version-history-input',
    row: 'd-flex',
    articleTitle: 'article-title',
    dropdownMessage: 'dropdown-message',
    itemsSection: 'items-section',
};

const VersionsDropdownContent = ({
    loading,
    versions,
    previewVersionId,
    handleActivateVersion,
    createNewVersion,
    handleCollapse,
    handlePreviewVersion,
    newVersionCreating,
    disableCreateNewVersionBtn,
    handleUpdateVersionName,
    handleDeleteVersion,
}) => {
    const darkMode = useSelector(selectDarkMode);

    const [showWordCount, setShowWordCount] = useState(true);
    const [showProgress, setShowProgress] = useState(true);
    const [customProgressBadge, setCustomProgressBadge] = useState(false);

    useEffect(() => {
        const isOptimizerBriefTab =
            localStorage.getItem(contentOptimizerLSTabKey) === briefOutlineTabs.brief.key;
        const isOutlineTab =
            localStorage.getItem(contentOptimizerBriefSubTabKey) === briefOutlineTabs.outline.key;

        setShowWordCount(!isOptimizerBriefTab);
        setShowProgress((isOptimizerBriefTab && !isOutlineTab) || !isOptimizerBriefTab);
        setCustomProgressBadge(isOptimizerBriefTab && !isOutlineTab);
    }, []);

    return (
        <div className={`${classes.versionDropdownMenuItemContent}`}>
            <div className={`${classes.itemsSection}`}>
                <VersionHistoryButton
                    label='Create new version'
                    disabled={!createNewVersion}
                    newVersionCreating={newVersionCreating}
                    handleCreateNewVersion={createNewVersion}
                    disableCreateNewVersionBtn={disableCreateNewVersionBtn}
                    isCreateNewVersionBtn={true}
                />

                {versions?.map((version) => {
                    return (
                        <VersionItem
                            key={version.id}
                            loading={loading}
                            version={version}
                            showSelected={version.id === previewVersionId}
                            handleActivateVersion={handleActivateVersion}
                            handlePreviewVersion={handlePreviewVersion}
                            handleUpdateVersionName={handleUpdateVersionName}
                            handleCollapse={handleCollapse}
                            handleDeleteVersion={handleDeleteVersion}
                            showWordCount={showWordCount}
                            showProgress={showProgress}
                            customProgressBadge={customProgressBadge}
                        />
                    );
                })}
            </div>

            <div className={`${classes.dropdownMessage} ${getThemeColorClass(darkMode)}`}>
                <Typography>
                    New versions are automatically saved every 15 minutes
                    <br />
                    (up to 8 versions) and deleted after 30 days.
                </Typography>
            </div>
        </div>
    );
};

export default VersionsDropdownContent;
